/**
 * Objet ModalProfil.
 *
 * Gérer l'interactivité du modal de profil de la direction sur la page About Us.
 *
 * @class ModalProfil
 */
export default class ModalProfil {
    constructor() {
        //console.log("Dans constructeur");
        // Init des boutons qui afficher les modals (modaux?)
        let liensOuvrirModals = document.querySelectorAll('.profil-modal__lien-afficher');
        // Ajouter le listener sur les liens
        Array.from(liensOuvrirModals).forEach((lienOuvrirModal) => lienOuvrirModal.addEventListener('click', () => this.afficherModal("modal-" + lienOuvrirModal.dataset.nom)));
        // Init des boutons qui ferment les modals (modaux?)
        let liensFermerModals = document.querySelectorAll('.profil-modal__lien-fermer');
        // Ajouter le listener sur les liens
        Array.from(liensFermerModals).forEach((lienFermerModal) => lienFermerModal.addEventListener('click', () => this.fermerModal("modal-" + lienFermerModal.dataset.nom)));
    }
    /**
     * Gérer un click sur le bouton « View Profile ».
     *
     * @private
     * @param string modalId  L'id du modal à a ouvrir
     * @memberof ModalProfil
     */
    afficherModal(modalId) {
        //console.log("Dans afficherModal");
        // Mettre la main sur le modal à ouvrir
        let modal = document.getElementById(modalId);
        // Afficher le modal
        modal.classList.add('profil-modal--visible');
    }
    /**
     * Gérer un click sur le « X » pour fermer le modal des profiles.
     *
     * @private
     * @param string modalId  L'id du modal à a ouvrir
     * @memberof ModalProfil
     */
    fermerModal(modalId) {
        //console.log("Dans fermerModal");
        // Mettre la main sur le modal à ouvrir
        let modal = document.getElementById(modalId);
        // Fermer le modal
        modal.classList.remove('profil-modal--visible');
    }
}
